'use client'

import {useTranslate} from '@local/hooks'
import {RetreatDetailsContext} from '@local/stores/contexts'
import {Button, SmallText} from '@local/ui/components'
import {ReactNode, useContext} from 'react'
import BedSVG from '@local/assets/svgs/icon-bed.svg'
import DateSVG from '@local/assets/svgs/icon-date.svg'
import EyeSVG from '@local/assets/svgs/icon-eye.svg'
import PaymentSVG from '@local/assets/svgs/icon-payment.svg'
import {formatPrice} from '@local/utils/currency'

export const RetreatDetails = () => {
	const locale = useTranslate()
	const {setIsOpen, product: productData} = useContext(RetreatDetailsContext)
	// const dates = productData.store.options.find(e => e.name === 'Date')?.values || [productData.datePeriod]

	const nextDates = productData?.nextDates?.map(e => e.period) || [productData.datePeriod]
	const minPrice = productData?.store?.priceRange?.minVariantPrice || {amount: 0, currency: 'EUR'}
	const formattedPrice = formatPrice(minPrice?.amount, `en-NL`, minPrice?.currency, {minimumFractionDigits: 0, maximumFractionDigits: 0}).replace(/\s/g, '')
	const nextDatesString = nextDates?.length > 1 ? nextDates.join('\n') : nextDates[0]

	return (
		<div className='w-full py-50 lg:py-60 lg:span-w-4 ml-auto span-mr-1-wide lg:text-right'>
			<ul className='pb-30'>
				{nextDates && (
					<TitleTextIcon
						title={locale('Next Dates')}
						text={nextDatesString ?? 'Dates coming soon'}>
						<DateSVG className='col-start-1 row-span-full w-16 h-16' />
					</TitleTextIcon>
				)}
				{productData?.specialGuests && (
					<TitleTextIcon
						title={locale('Hosted by')}
						text={productData?.specialGuests}>
						<EyeSVG className='col-start-1 row-span-full w-16 h-16' />
					</TitleTextIcon>
				)}
				{productData?.accomodation && (
					<TitleTextIcon
						title={locale('Accommodation')}
						text={productData?.accomodation}>
						<BedSVG className='col-start-1 row-span-full w-16 h-16' />
					</TitleTextIcon>
				)}
				{formattedPrice && (
					<TitleTextIcon
						title={locale('Pricing starts at')}
						text={formattedPrice}>
						<PaymentSVG className='col-start-1 row-span-full w-16 h-16' />
					</TitleTextIcon>
				)}
			</ul>
			<Button
				className='span-w-8 lg:span-w-2'
				variant='primary'
				border
				small
				onClick={() => setIsOpen(true)}>
				{locale('Experience Details')}
			</Button>
		</div>
	)
}

const TitleTextIcon = ({children, title, text}: { children: ReactNode, title:string, text: string }) => (
	<li className='grid grid-cols-[auto_1fr] lg:grid-cols[auto_1fr_1fr] justify-items-start items-start lg:items-center gap-y-5 gap-x-10 py-10 border-t border-grey-1/50'>
		{children}
		<h3 className='text-black text-11 mt-3 text-left leading-none uppercase tracking-doubleWider col-start-2 row-start-1'>{title}:</h3>
		<SmallText textColor='grey-2' className='col-start-2 lg:col-start-3 lg-max:row-start-2 mt-0 !leading-moderate'>{text}</SmallText>
	</li>
)
